import React from "react";
import styled from "styled-components";
import LifeAtButton from "@common/LifeAtButton/LifeAtButton";
import LoadingSpinner from "@common/LoadingSpinner/LoadingSpinner";
import RefreshIcon from "@icons/RefreshIcon.svg";
import Styles from "@themes/Styles";
import { START_TIMER_LABEL } from "./TimerWidgetConstants";

const StyledTimerState = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`;
const StyledTimerCountdown = styled.span`
    font-size: 54px;
    line-height: 50px;
    padding-left: 14px;
    color: ${({ theme }) => theme.textColorPrimary};
`;

const StyledTimerActions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-self: center;
`;

const StyledToggleTimerButton = styled(LifeAtButton)`
    min-width: 105px;
    justify-content: center;

    border: 1.5px solid ${({ theme }) => theme.textColorPrimary} !important;
    border-radius: ${Styles.borderRadiusNormal};
    padding: 6px 25px;
`;

const StyledResetIcon = styled(RefreshIcon)`
    stroke: ${({ theme }) => theme.iconColor};
`;

const TimerActionsLoaderContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
`;
interface TimerCountdownAndActionsRowProps {
    readonly timerDisplayText: string | undefined;
    readonly isRunning: boolean;
    readonly stopTimerActionButtonLabel: string;
    readonly canEditSettings: boolean;
    readonly onTimerToggle: (() => void) | undefined;
    readonly onTimerReset: (() => void) | undefined;
    readonly isServerActionLoading?: boolean;
}
export default function TimerCountdownAndActionsRow(props: TimerCountdownAndActionsRowProps) {
    const timerActions = () => {
        if (props.isServerActionLoading) {
            return (
                <TimerActionsLoaderContainer>
                    <LoadingSpinner />
                </TimerActionsLoaderContainer>
            );
        } else {
            return (
                <StyledTimerActions>
                    <StyledToggleTimerButton
                        text={props.isRunning ? props.stopTimerActionButtonLabel : START_TIMER_LABEL}
                        isLink={false}
                        handleClick={props.onTimerToggle}
                    />
                    <LifeAtButton icon={<StyledResetIcon />} isLink={false} handleClick={props.onTimerReset} />
                </StyledTimerActions>
            );
        }
    };

    return (
        <StyledTimerState>
            <StyledTimerCountdown>{props.timerDisplayText ?? "25:00"}</StyledTimerCountdown>
            {!props.canEditSettings && timerActions()}
        </StyledTimerState>
    );
}
